import { render, staticRenderFns } from "./QuoteBuilderPartItem.vue?vue&type=template&id=16fad9c8"
import script from "./QuoteBuilderPartItem.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderPartItem.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderPartItem.vue?vue&type=style&index=0&id=16fad9c8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16fad9c8')) {
      api.createRecord('16fad9c8', component.options)
    } else {
      api.reload('16fad9c8', component.options)
    }
    module.hot.accept("./QuoteBuilderPartItem.vue?vue&type=template&id=16fad9c8", function () {
      api.rerender('16fad9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderParts/QuoteBuilderPartItem.vue"
export default component.exports